export default __webpack_public_path__ + "static/ProximaNova-Extrabld-4d1a0837eeacad40023f8d45e9f1215b.woff2";